<template>
  <div class="y-price-box">
    <span class="y-price" :style="{ color: color, fontSize, lineHeight }">
      {{ currency }} {{ price }}
    </span>
    <span v-if="localCurrency && localCurrency != currency" class="local-price"
      >{{ subtitle ? subtitle : t("shell.common.localCurrency") }}
      <span>{{ localCurrency }}</span>
      <span :style="localPriceNumStyle">{{ localPrice }}</span>
    </span>
  </div>
</template>

<script setup>
import _ from "lodash";
import numeral from "numeral";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const props = defineProps({
  price: {
    type: Number
  },
  decimal: {
    type: Number,
    default: 0
  },
  color: {
    type: String,
    default: "var(--y-text-color)"
  },
  fontSize: {
    type: String,
    default: "var(--y-price-font-size)"
  },
  lineHeight: {
    type: String,
    default: "var(--y-price-font-size)"
  },
  format: {
    type: String,
    default: "0,0.[00]"
  },
  currency: {
    type: String,
    default: ""
  },
  localPrice: {
    type: Number,
    default: 0
  },
  localCurrency: {
    type: String,
    default: ""
  },
  subtitle: {
    type: String,
    default: ""
  },
  localPriceNumStyle: {
    type: Object,
    default: () => {}
  }
});

const price = computed(() => {
  const _price = props.price;
  if (!_price && _price !== 0) {
    return 0;
  }

  return numeral(_price).format(props.format);
});
const localPrice = computed(() => {
  const _price = props.localPrice;
  if (!props.price) {
    return 0;
  }

  return numeral(_price).format(props.format);
});
</script>

<style lang="scss" scoped>
.y-price-box {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  .local-price {
    white-space: nowrap;
    text-align: right;
    color: #949494;
    font-size: 12px;
    line-height: 12px;
    font-weight: 300;
    font-family: var(--y-price-font);
  }
}
.y-price {
  --y-price-color: #292929;
  --y-price-font-size: 26px;
  font-size: var(--y-price-font-size);
  font-family: var(--y-price-font);
  color: var(--y-price-color);
  line-height: 26px;
}
</style>
